import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";

import ScrollTotop from "./scrollToTop";

//Compornts
import Intro from "./components/intro/imgButton";
import UserInfo from "./components/intro/imgText4Button";
import UserInfoName from "./components/intro/imgTextButton";
import Ready from "./components/ready/ready";
import Moving from "./components/moving/moving";
import ChatBox from "./components/chat/chat";
import Quize from "./components/quize/quize";
import Wrong from "./components/wrong/wrong";
import Answer from "./components/answer/answer";
import Clear from "./components/clear/clear";

//CSS
import "./index.css";

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [userName, setUserName] = useState("");

  const handleFinish = ({ route, defaultPath, state }) => {
    navigate(route || defaultPath, {
      state,
    });
  };

  return (
    <>
      <ScrollTotop />

      <Routes>
        <Route
          path="/"
          element={<Intro onFinish={handleFinish} defaultPath="/login" />}
        />
        <Route
          path="/login"
          element={
            <UserInfo
              userName={userName}
              setUserName={setUserName}
              onFinish={handleFinish}
              defaultPath="/story"
            />
          }
        />
        {/* <Route
          path="/stage2"
          element={
            <UserInfoName
              userName={userName}
              setUserName={setUserName}
              onFinish={handleFinish}
              defaultPath="/story2"
            />
          }
        /> */}
        <Route
          path="/story"
          element={
            <ChatBox
              key="story"
              onFinish={handleFinish}
              defaultPath="/moving"
            />
          }
        />
        <Route
          path="/story2"
          element={
            <ChatBox
              key="story2"
              onFinish={handleFinish}
              defaultPath="/stage1"
            />
          }
        />
        <Route path="/moving" element={<Moving onFinish={handleFinish} />} />
        <Route path="/ready" element={<Ready />} />
        <Route
          path="/stage1"
          element={
            <ChatBox key="stage1" onFinish={handleFinish} defaultPath="/quiz" />
          }
        />
        <Route
          path="/stage2"
          element={
            <ChatBox key="stage2" onFinish={handleFinish} defaultPath="/quiz" />
          }
        />
        <Route
          path="/stage3"
          element={
            <ChatBox key="stage3" onFinish={handleFinish} defaultPath="/quiz" />
          }
        />
        <Route
          path="/writeDream"
          element={
            <ChatBox
              key="writeDream"
              onFinish={handleFinish}
              defaultPath="/take_picture"
            />
          }
        />
        <Route
          path="/take_picture"
          element={<ChatBox key="take_picture" onFinish={handleFinish} />}
        />
        <Route path="/quiz" element={<Quize key={location.key} />} />
        <Route path="/wrong" element={<Wrong />} />
        <Route path="/answer" element={<Answer key={location.key} />} />
        <Route path="/clear" element={<Clear />} />
      </Routes>
    </>
  );
}

//  <Quize
//    answerData={"keyword"}
//    DateVal={"DATA3"}
//    titImgclassName={"infoTit"}
//    hintWhetherIs={false}
//    hintContent={""}
//  />;
